namespace Matrix.Data {
    export interface DocumentStoreForm {
        DocumentId: Serenity.StringEditor;
        DocumentUpload: Serenity.ImageUploadEditor;
        Name: Serenity.StringEditor;
        DocumentType: Serenity.LookupEditor;
        Path: Serenity.LookupEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class DocumentStoreForm extends Serenity.PrefixedContext {
        static formKey = 'Data.DocumentStore';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DocumentStoreForm.init)  {
                DocumentStoreForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.ImageUploadEditor;
                var w2 = s.LookupEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(DocumentStoreForm, [
                    'DocumentId', w0,
                    'DocumentUpload', w1,
                    'Name', w0,
                    'DocumentType', w2,
                    'Path', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
